export default __webpack_public_path__ + "60e2f545f8858a82bf5986547c81dbfa.jpg";